import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommonState, CONFIGURATION_FEATURE_KEY } from './common.reducer';

export const getCommonState = createFeatureSelector<CommonState>(
  CONFIGURATION_FEATURE_KEY
);

export const getConfiguration = createSelector(
  getCommonState,
  (state: CommonState) => state.config
);

export const getUser = createSelector(
  getCommonState,
  (state: CommonState) => state.user
);

export const getUserEntitlements = createSelector(
  getCommonState,
  (state: CommonState) => state.user?.entitlements
);
